import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { LanguageProvider } from './hooks/useTranslation';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {LoginPage} from "./components/LoginPage";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoggedHomePage from "./components/LoggedHomePage";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ landingPageData }) => (
  <div>
    <Navigation />
    <Header data={landingPageData.Header} />
    <Features data={landingPageData.Features} />
    <About data={landingPageData.About} />
    <Services data={landingPageData.Services} />
    {/*<Team data={landingPageData.Team} /> */}
    <Contact data={landingPageData.Contact} />
  </div>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const clientId = "949968017055-0mrgdech2h6ffchqlk9la60p81fibssb.apps.googleusercontent.com";

  return (
    <div className="custom-root-bar">
      <LanguageProvider>
        <GoogleOAuthProvider clientId={clientId}>
          <Router>
            <Switch>
              <Route exact path="/">
                <HomePage landingPageData={landingPageData} />
              </Route>
              <Route path="/login">
                <LoginPage />
              </Route>
                <Route path="/home">
                <LoggedHomePage />
              </Route>
            </Switch>
          </Router>
        </GoogleOAuthProvider>
      </LanguageProvider>
    </div>
  );
};

export default App;
